import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap } from 'rxjs/operators';
import { MeteringPointService } from '@appStore/metering-points/services/metering-point.service';

import * as actions from '@appStore/metering-points/actions';
import * as meteringPointGroupActions from '@appStore/metering-points/actions/metering-point-group.actions';
import { MeteringPointGroupActionTypes } from '@appStore/metering-points/actions/metering-point-group.actions';

@Injectable()
export class MeteringPointGroupsEffects {
  constructor(private router: Router, private meteringPointService: MeteringPointService, private actions$: Actions) {}

  loadData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MeteringPointGroupActionTypes.LoadMeteringPointGroupData),
      exhaustMap(action => {
        return this.meteringPointService.getMeteringPointGroups().pipe(
          map(meteringPointGroups => new meteringPointGroupActions.LoadMeteringPointsGroupsSuccess(meteringPointGroups)),
          catchError(error => of(new meteringPointGroupActions.LoadMeteringPointsGroupsFail(error)))
        );
      })
    );
  });
  
  remove = createEffect(() => {
    return this.actions$.pipe(
      ofType(MeteringPointGroupActionTypes.RemoveMeteringPointGroup),
      map((action: actions.RemoveMeteringPointGroup) => action.payload),
      exhaustMap(meteringGroup => {
        return this.meteringPointService.removeMeteringPointGroup(meteringGroup).pipe(
          map(mg => new meteringPointGroupActions.RemoveMeteringPointGroupSuccess(mg)),
          catchError(error => of(new meteringPointGroupActions.RemoveMeteringPointGroupFail(error)))
        );
      })
    );
  });
  
  add = createEffect(() => {
    return this.actions$.pipe(
      ofType(MeteringPointGroupActionTypes.AddMeteringPointGroup),
      map((action: actions.AddMeteringPointGroup) => action.payload),
      exhaustMap(meteringGroup => {
        return this.meteringPointService.addMeteringPointGroup(meteringGroup).pipe(
          map(mg => new meteringPointGroupActions.AddMeteringPointGroupSuccess(mg)),
          catchError(error => of(new meteringPointGroupActions.AddMeteringPointGroupFail(error)))
        );
      })
    );
  });
  
  update = createEffect(() => {
    return this.actions$.pipe(
      ofType(MeteringPointGroupActionTypes.UpdateMeteringPointGroup),
      map((action: actions.UpdateMeteringPointGroup) => action.payload),
      exhaustMap(meteringGroup => {
        return this.meteringPointService.updateMeteringPointGroup(meteringGroup).pipe(
          map(mg => new meteringPointGroupActions.UpdateMeteringPointGroupSuccess(mg)),
          catchError(error => of(new meteringPointGroupActions.UpdateMeteringPointGroupFail(error)))
        );
      })
    );
  });
  
  bulkUpdate = createEffect(() => {
    return this.actions$.pipe(
      ofType(MeteringPointGroupActionTypes.BulkUpdateMeteringPointGroups),
      map((action: actions.BulkUpdateMeteringPointGroups) => action.payload),
      exhaustMap(meteringGroups => {
        return this.meteringPointService.bulkUpdateMeteringPointGroups(meteringGroups).pipe(
          map(
            meteringPointGroups => new meteringPointGroupActions.BulkUpdateMeteringPointGroupsSuccess(meteringPointGroups)
          ),
          catchError(error => of(new meteringPointGroupActions.BulkUpdateMeteringPointGroupsFail(error)))
        );
      })
    );
  });
}
